:host {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    background-color: var(--sustainability-theme-bgr);
    gap: 20px;
    padding: 32px 40px 40px;
    cursor: pointer;
    color: var(--sustainability-theme-text);

    .headline {
        @include typo-ws-copy-xl;

        hyphens: auto;
    }

    .content {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 42px;
        align-items: flex-start;
        width: 100%;
    }

    .icon-bg {
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--sustainability-theme-icon);
        height: 140px;
        width: 140px;
        border: 1px solid var(--sustainability-theme-icon);
        border-radius: 50%;
        transition: all 200ms;
    }

    .icon {
        scale: 1.9;
    }
}

:host(:hover) {
    .icon-bg {
        color: var(--sustainability-theme-icon-hover);
        background-color: var(--sustainability-theme-icon-bgr-hover);
        border: 1px solid var(--sustainability-theme-icon-bgr-hover);
    }
}

@include mq-1 {
    :host {
        padding: 24px 20px;
        gap: 16px;

        .content {
            gap: 28px;
        }

        .icon-bg {
            height: 80px;
            width: 80px;
        }

        .icon {
            scale: 1;
        }
    }
}
